/* Pendant builder — canvas pavé renderer: builds the pendant stone-by-stone in real time */
(function () {
  var stage = document.getElementById('pb-stage');
  var canvas = document.getElementById('pb-canvas');
  if (!stage || !canvas) return;
  var ctx = canvas.getContext('2d');

  var textInput = document.getElementById('pb-text');
  var fontBtns = Array.prototype.slice.call(document.querySelectorAll('[data-pb-font]'));
  var bailBtns = Array.prototype.slice.call(document.querySelectorAll('[data-pb-bail-opt]'));
  var cta = document.querySelector('[data-pb-cta]');

  var state = { text: '', font: 'Bungee', fontLabel: 'Bungee', bail: 'money', bailLabel: 'Money bag' };

  /* ---------- seeded rng (stable stone layout per design) ---------- */
  function hashStr(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* ---------- one diamond stone ---------- */
  function drawStone(c, x, y, r, rng) {
    var tone = rng();
    // dark seat
    c.fillStyle = 'rgba(8,8,10,0.92)';
    c.beginPath(); c.arc(x, y, r, 0, 6.2832); c.fill();
    // stone body, light from top-left
    var g = c.createRadialGradient(x - r * 0.35, y - r * 0.35, r * 0.08, x, y, r);
    g.addColorStop(0, '#ffffff');
    g.addColorStop(0.42, tone > 0.82 ? '#e8f1f8' : '#dde4ea');
    g.addColorStop(0.78, '#8d97a1');
    g.addColorStop(1, '#454d56');
    c.fillStyle = g;
    c.beginPath(); c.arc(x, y, r * 0.94, 0, 6.2832); c.fill();
    // facet glint
    c.fillStyle = 'rgba(255,255,255,0.95)';
    c.beginPath(); c.arc(x - r * 0.3, y - r * 0.36, r * 0.26, 0, 6.2832); c.fill();
    // occasional sparkle star
    if (tone > 0.93) {
      c.strokeStyle = 'rgba(255,255,255,0.85)';
      c.lineWidth = Math.max(1, r * 0.12);
      c.beginPath();
      c.moveTo(x - r * 1.5, y); c.lineTo(x + r * 1.5, y);
      c.moveTo(x, y - r * 1.5); c.lineTo(x, y + r * 1.5);
      c.stroke();
    }
  }

  function metalEdge(c, drawFn, w) {
    var g = c.createLinearGradient(0, -w, 0, w);
    g.addColorStop(0, '#f4f6f8'); g.addColorStop(0.5, '#a7b0b9'); g.addColorStop(1, '#e3e8ed');
    c.strokeStyle = g; c.lineWidth = w; c.lineJoin = 'round'; c.lineCap = 'round';
    drawFn();
  }

  /* ---------- fill any mask with pavé ---------- */
  function paveMask(c, mask, x0, y0, stoneR, seed) {
    var rng = mulberry32(seed);
    var d = mask.data, W = mask.width, H = mask.height;
    function alphaAt(x, y) {
      x |= 0; y |= 0;
      if (x < 0 || y < 0 || x >= W || y >= H) return 0;
      return d[(y * W + x) * 4 + 3];
    }
    var step = stoneR * 1.42, inset = stoneR * 1.15, row = 0;
    for (var y = step * 0.6; y < H; y += step, row++) {
      for (var x = step * 0.6 + (row % 2 ? step * 0.5 : 0); x < W; x += step) {
        var jx = x + (rng() - 0.5) * step * 0.4;
        var jy = y + (rng() - 0.5) * step * 0.4;
        if (alphaAt(jx, jy) < 128) continue;
        if (alphaAt(jx - inset, jy) < 128 || alphaAt(jx + inset, jy) < 128 ||
            alphaAt(jx, jy - inset) < 128 || alphaAt(jx, jy + inset) < 128) continue;
        drawStone(c, x0 + jx, y0 + jy, stoneR * (0.85 + rng() * 0.32), rng);
      }
    }
  }

  function maskFrom(drawFn, w, h) {
    var off = document.createElement('canvas');
    off.width = Math.max(2, Math.ceil(w)); off.height = Math.max(2, Math.ceil(h));
    var o = off.getContext('2d', { willReadFrequently: true });
    drawFn(o);
    return o.getImageData(0, 0, off.width, off.height);
  }

  /* ---------- bail shapes (120x120 box) ---------- */
  function bailPath(kind) {
    var p = new Path2D();
    if (kind === 'money') {
      p.moveTo(46, 30);
      p.bezierCurveTo(46, 15, 53, 8, 60, 8);
      p.bezierCurveTo(67, 8, 74, 15, 74, 30);
      p.bezierCurveTo(83, 40, 87, 55, 80, 70);
      p.bezierCurveTo(73, 85, 67, 92, 60, 92);
      p.bezierCurveTo(53, 92, 47, 85, 40, 70);
      p.bezierCurveTo(33, 55, 37, 40, 46, 30);
      p.closePath();
    } else if (kind === 'crown') {
      p.moveTo(28, 84); p.lineTo(22, 42); p.lineTo(40, 56);
      p.lineTo(60, 26); p.lineTo(80, 56); p.lineTo(98, 42);
      p.lineTo(92, 84); p.closePath();
    } else if (kind === 'gem') {
      p.moveTo(60, 8); p.lineTo(96, 34); p.lineTo(60, 94); p.lineTo(24, 34);
      p.closePath();
    }
    return p;
  }

  function drawBail(c, cx, topY, kind, seed) {
    var S = 120, x0 = cx - S / 2;
    if (kind === 'loop') {
      // ring band mask
      var mask = maskFrom(function (o) {
        o.strokeStyle = '#fff'; o.lineWidth = 20; o.lineCap = 'round';
        o.beginPath();
        if (o.roundRect) { o.roundRect(38, 14, 44, 72, 22); o.stroke(); }
        else { o.rect(38, 14, 44, 72); o.stroke(); }
      }, S, 100);
      c.save();
      metalEdge(c, function () {
        c.beginPath();
        if (c.roundRect) c.roundRect(x0 + 38, topY + 14, 44, 72, 22); else c.rect(x0 + 38, topY + 14, 44, 72);
        c.stroke();
      }, 22);
      paveMask(c, mask, x0, topY, 7.5, seed);
      c.restore();
      return 100;
    }
    var path = bailPath(kind);
    var mask2 = maskFrom(function (o) { o.fillStyle = '#fff'; o.fill(path); }, S, 100);
    c.save();
    c.translate(x0, topY);
    metalEdge(c, function () { c.stroke(path); }, 7);
    // tie band on the money bag (polished, no stones)
    if (kind === 'money') {
      var tg = c.createLinearGradient(0, 20, 0, 34);
      tg.addColorStop(0, '#eef1f4'); tg.addColorStop(1, '#9aa4ae');
      c.fillStyle = tg;
      c.beginPath(); c.roundRect ? c.roundRect(44, 20, 32, 13, 6) : c.rect(44, 20, 32, 13); c.fill();
    }
    c.restore();
    paveMask(c, mask2, x0, topY, 7.5, seed + 7);
    if (kind === 'gem') {
      // facet lines over the stones
      c.save();
      c.translate(x0, topY);
      c.strokeStyle = 'rgba(40,45,52,0.55)'; c.lineWidth = 1.4;
      c.beginPath();
      c.moveTo(24, 34); c.lineTo(96, 34);
      c.moveTo(60, 8); c.lineTo(46, 34); c.lineTo(60, 94);
      c.moveTo(60, 8); c.lineTo(74, 34); c.lineTo(60, 94);
      c.stroke(); c.restore();
    }
    return 100;
  }

  /* ---------- rope chain ---------- */
  function drawChain(c, W) {
    var rng = mulberry32(42);
    function yAt(t) { return 44 - Math.sin(t * Math.PI) * 34; }
    for (var t = 0; t <= 1.0001; t += 0.022) {
      var x = t * W, y = yAt(t);
      var r = 5.4 + rng() * 1.2;
      var g = c.createRadialGradient(x - 2, y - 2, 1, x, y, r);
      g.addColorStop(0, '#f2f5f7'); g.addColorStop(0.6, '#aeb7c0'); g.addColorStop(1, '#6d767f');
      c.fillStyle = g;
      c.beginPath(); c.arc(x, y, r, 0, 6.2832); c.fill();
    }
  }

  /* ---------- main render: pendant + floor shadow + reflection ---------- */
  function render() {
    var W = stage.clientWidth;
    if (!W) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var text = (state.text.trim() || 'YOUR NAME').toUpperCase();
    var isPlaceholder = !state.text.trim();
    var fontFam = '"' + state.font + '", sans-serif';

    // measure + fit
    var meas = document.createElement('canvas').getContext('2d');
    var size = 120;
    meas.font = size + 'px ' + fontFam;
    var tw = Math.max(1, meas.measureText(text).width);
    size = Math.min(120, Math.floor(size * (W - 48) / tw));
    size = Math.max(34, size);
    meas.font = size + 'px ' + fontFam;
    tw = meas.measureText(text).width;

    var chainH = 56, bailH = 100, gapBail = 8, padTop = 10, padBottom = 14;
    var textH = size * 1.32;
    var pendantH = padTop + chainH + bailH + gapBail + textH + padBottom;
    var reflH = Math.min(84, pendantH * 0.3);
    var seedBase = hashStr(text + '|' + state.font + '|' + state.bail);
    var cx = W / 2;

    // --- pendant, drawn offscreen ---
    var pCan = document.createElement('canvas');
    pCan.width = Math.round(W * dpr);
    pCan.height = Math.round(pendantH * dpr);
    var p = pCan.getContext('2d');
    p.setTransform(dpr, 0, 0, dpr, 0, 0);

    drawChain(p, W);

    var bailTop = padTop + chainH - 6;
    p.save();
    var rg = p.createLinearGradient(0, bailTop - 4, 0, bailTop + 12);
    rg.addColorStop(0, '#eef1f4'); rg.addColorStop(1, '#9aa4ae');
    p.strokeStyle = rg; p.lineWidth = 6;
    p.beginPath(); p.arc(cx, bailTop + 4, 8, 0, 6.2832); p.stroke();
    p.restore();
    drawBail(p, cx, bailTop + 8, state.bail, seedBase);

    var textTop = bailTop + 8 + bailH + gapBail;
    // soft floor shadow under the text
    p.save();
    var shY = textTop + textH * 0.78;
    var sh = p.createRadialGradient(cx, shY, 8, cx, shY, Math.max(60, tw * 0.44));
    sh.addColorStop(0, 'rgba(20,24,28,0.20)');
    sh.addColorStop(1, 'rgba(20,24,28,0)');
    p.fillStyle = sh;
    p.fillRect(cx - tw / 2 - 50, shY - textH * 0.4, tw + 100, textH * 0.8);
    p.restore();

    if (!isPlaceholder) {
      var offW = Math.ceil(tw + size * 0.5), offH = Math.ceil(size * 1.5);
      var mask = maskFrom(function (o) {
        o.font = size + 'px ' + fontFam;
        o.textBaseline = 'middle';
        o.fillStyle = '#fff';
        o.fillText(text, size * 0.25, offH / 2);
      }, offW, offH);
      var x0 = cx - offW / 2, y0 = textTop;
      p.save();
      p.font = size + 'px ' + fontFam;
      p.textBaseline = 'middle';
      metalEdge(p, function () { p.strokeText(text, x0 + size * 0.25, y0 + offH / 2); }, Math.max(4, size * 0.07));
      p.restore();
      paveMask(p, mask, x0, y0, Math.max(4, size / 19), seedBase + 99);
    } else {
      p.save();
      p.font = size + 'px ' + fontFam;
      p.textBaseline = 'middle';
      p.fillStyle = 'rgba(30,34,38,0.20)';
      p.fillText(text, cx - tw / 2, textTop + textH / 2);
      p.restore();
    }

    // --- reflection: flipped bottom slice, faded ---
    var rCan = document.createElement('canvas');
    var rw = Math.round(W * dpr), rh = Math.round(reflH * dpr);
    rCan.width = rw; rCan.height = rh;
    var r = rCan.getContext('2d');
    r.save();
    r.scale(dpr, dpr);
    r.translate(0, reflH);
    r.scale(1, -1);
    r.drawImage(pCan, 0, (pendantH - reflH) * dpr, rw, rh, 0, 0, W, reflH);
    r.restore();
    r.globalCompositeOperation = 'destination-in';
    var fg = r.createLinearGradient(0, 0, 0, rh);
    fg.addColorStop(0, 'rgba(0,0,0,0.30)');
    fg.addColorStop(1, 'rgba(0,0,0,0)');
    r.fillStyle = fg;
    r.fillRect(0, 0, rw, rh);

    // --- composite ---
    var H = pendantH + reflH;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    canvas.style.height = Math.round(H) + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    ctx.drawImage(pCan, 0, 0, W, pendantH);
    ctx.drawImage(rCan, 0, pendantH - 4, W, reflH);
  }

  var raf = null;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { raf = null; render(); });
  }

  if (textInput) {
    textInput.addEventListener('input', function () {
      state.text = textInput.value.slice(0, 10);
      schedule();
    });
  }
  fontBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      fontBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
      state.font = btn.getAttribute('data-pb-font');
      state.fontLabel = btn.getAttribute('data-pb-font-label') || state.font;
      schedule();
    });
  });
  bailBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      bailBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
      state.bail = btn.getAttribute('data-pb-bail-opt');
      state.bailLabel = btn.getAttribute('data-pb-bail-label') || state.bail;
      schedule();
    });
  });

  var rsz;
  window.addEventListener('resize', function () {
    clearTimeout(rsz); rsz = setTimeout(schedule, 150);
  });

  if (cta) {
    cta.addEventListener('click', function () {
      var t = state.text.trim().toUpperCase() || '(no text entered)';
      try {
        sessionStorage.setItem('mj-pendant-config', JSON.stringify({
          text: t, font: state.fontLabel, bail: state.bailLabel
        }));
      } catch (e) { /* storage unavailable — quote page still works */ }
      window.location.href = '/pages/quote';
    });
  }

  function boot() {
    try {
      var loads = ['Bungee', 'Titan One', 'Alfa Slab One', 'Monoton', 'Cinzel Decorative', 'Pattaya'].map(function (f) {
        return document.fonts.load('100px "' + f + '"');
      });
      Promise.all(loads).then(schedule).catch(schedule);
    } catch (e) { schedule(); }
  }
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(boot); }
  else { boot(); }
  schedule();
})();
